import React, { useEffect, useState } from 'react';
import {useTranslation} from 'react-i18next';
import Home from './components/Home/Home';
import './components/Home/styles/Home.css';
import './components/Home/styles/Global.css';

import {createBrowserHistory} from 'history';
import {BrowserRouter} from 'react-router-dom';
import UserService from './components/Home/services/UserService';
import {avviaAccesso, accessoPronto} from './avvio';
import HttpService from './components/Home/services/HttpService';
import { BetslipProvider } from './context/BetslipContext';
import i18next from 'i18next';

const defaultHistory = createBrowserHistory();

function App({history = defaultHistory}) {
  /* AL CAMBIO DI LINGUA SI RIDISEGNA TUTTO. Le parole scritte con
     i18next.t() (fuori dai componenti, negli elenchi, nei servizi) non
     ascoltano la lingua da sole: ascolta qui la radice, e ridisegnando lei si
     ridisegna tutto quello che sta sotto, che rilegge le parole nella lingua
     nuova. Lo stato (schedina, finestre aperte, campi scritti) resta. */
  useTranslation();
  /* L'accesso si controlla gia' da index.js, insieme alla skin: qui si
     aspetta solo che abbia finito, e se ha gia' finito non si aspetta niente. */
  const [isAuthReady, setIsAuthReady] = useState(accessoPronto);

  useEffect(() => {
    let vivo = true;
    avviaAccesso().then((authenticated) => {
      console.log('Auth initialized, authenticated:', authenticated);
      if (vivo) setIsAuthReady(true);
    });
    return () => { vivo = false; };
  }, []);

  /* Lo stesso schermo d'avvio di index.html: chi arriva vede una cosa
     sola, non due attese diverse una dopo l'altra. */
  if (!isAuthReady) {
    return <div className="lvc-avvio" aria-label={i18next.t('Caricamento')}><span className="lvc-avvio-barra"/></div>;
  }

  return (
      <BrowserRouter>
        <BetslipProvider>
          <div className="App">
            <Home
                history={history}
                userService={UserService}
                httpService={HttpService}
            />
          </div>
        </BetslipProvider>
      </BrowserRouter>
  );
}

export default App;
